import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import VisibilityIcon from "@mui/icons-material/Visibility";

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2)
    }
  },
  header: {
    opacity: "0.5",
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(10)
    }
  },
  image: {
    minHeight: 72,
    maxHeight: 72,
    [theme.breakpoints.down("sm")]: {
      minHeight: 64,
      maxHeight: 64
    }
  }
}));

export default function SlideOutBanner(props) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      color={theme.palette.common.white}
      pt={theme.sizes.topNavBarHeight + "px"}
      bgcolor={theme.palette.secondary.main}
      px={4}
      pb={4}
    >
      <Box
        className={classes.header}
        display="flex"
        flexDirection="row"
        alignItems="center"
        py={2.5}
      >
        <VisibilityIcon className={classes.icon} />
        <Typography variant="caption">
          This is only visible to you because you are an admin:
        </Typography>
      </Box>
      <Box display="flex">
        <img src={props.image} alt="Logo" className={classes.image} />
        <Box display="flex" flexDirection="column" pl={3}>
          <Typography variant="subtitle1">{props.title}</Typography>
          <Typography variant="body2" className="transparent">
            {props.subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

SlideOutBanner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.any
};
